






























import hasPermission from '@/libs/permission';
import {
  Component, Vue, Prop, Watch,
} from 'vue-property-decorator';
import { mapState } from 'vuex';

import SidebarItem from './SidebarItem.vue';

@Component({
  name: 'sidebar-tree',
  components: {
    SidebarItem,
  },
  computed: mapState(['sidebarCollapsed']),
})
export default class SidebarTree extends Vue {
  @Prop({ required: true }) title!: string;
  @Prop(String) image!: string;
  @Prop({ default: 0 }) level!: number;
  @Prop(Array) children!: SidebarItemInterface[];
  @Prop(String) to!: string;

  environment = process.env.VUE_APP_ENVIRONMENT || '';
  sidebarCollapsed!: boolean;
  active = false;
  opened = false;
  $refs!: {
    'sidebar-child': HTMLDivElement;
  }

  mounted() {
    this.checkActive();
    this.opened = this.active;
  }

  @Watch('$route')
  onRouteChange() {
    this.checkActive();
  }

  get sidebarItems() {
    return this.children.filter((e) => hasPermission(e.permission, e.environment, e.isInternal));
  }

  toggle() {
    const element = this.$refs['sidebar-child'];
    const height = element.scrollHeight;
    if (this.opened) {
      const elementTransition = element.style.transition;
      element.style.transition = '';

      requestAnimationFrame(() => {
        element.style.transition = elementTransition;
        element.style.height = `${height}px`;

        requestAnimationFrame(() => {
          element.style.height = `${0}px`;
          this.opened = false;
        });
      });
    } else {
      element.style.height = `${height}px`;

      element.addEventListener('transitionend', function handler() {
        element.removeEventListener('transitionend', handler);
        element.style.height = '';
      });

      this.opened = true;
    }
  }

  checkActive() {
    this.active = this.$route.matched.find((e) => e.path.startsWith(this.to)) !== undefined;
  }
}
